"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
// NOTE: onButtonClick is not a submit handler;
// it signals to the parent form which button invoked the submit action
// (which is important for multi-step forms where multiple submits can occur i.e. back/forward)
var Button = function (_a) {
  var field = _a.field,
    onButtonClick = _a.onButtonClick;
  return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement("button", {
    type: "submit",
    value: field.model.title,
    name: field.buttonField.name,
    id: field.buttonField.id,
    onClick: function () {
      return onButtonClick(field.buttonField.name);
    }
  }, field.model.title));
};
exports.default = Button;